var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4601 36.824C45.4913 33.5914 46.666 29.7662 46.666 25.6666C46.666 14.0686 37.264 4.66663 25.666 4.66663C14.068 4.66663 4.66602 14.0686 4.66602 25.6666C4.66602 37.2646 14.068 46.6666 25.666 46.6666C29.7656 46.6666 33.5908 45.4919 36.8234 43.4607L43.3215 49.9588C45.1541 51.7915 48.1255 51.7915 49.9582 49.9588C51.7909 48.1261 51.7909 45.1547 49.9582 43.3221L43.4601 36.824ZM25.666 39.6666C33.398 39.6666 39.666 33.3986 39.666 25.6666C39.666 17.9346 33.398 11.6666 25.666 11.6666C17.934 11.6666 11.666 17.9346 11.666 25.6666C11.666 33.3986 17.934 39.6666 25.666 39.6666Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8913 18.242L33.0906 31.4413L31.4407 33.0912L18.2414 19.8919L19.8913 18.242Z",
    fill: "#888888"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4407 18.242L33.0906 19.8919L19.8913 33.0912L18.2414 31.4413L31.4407 18.242Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResult);
export default __webpack_public_path__ + "static/media/NoResult.354dfa8c44f4c0a987a3320321c31311.svg";
export { ForwardRef as ReactComponent };